'use strict';

/** Meant to be used on a scrollable object containing elements of which the content depend on an array.
 * Attributes:
    * smartlist="bigarray" array on which you want to base a list. "array | filter:filter" is allowed.
    * ng-model="result" array that holds the values from the bigarray that are currently scrolled into view.
    * sl-margin="1" Optional, 1 by default. Determines how many additional items are generated out of sight to act as a buffer.
    * sl-lineheight="18" Optional, 18 by default. Pixelheight of the generated objects. incorrect value may decrease user experience,
	for example by having empty space at the bottom or not being able to scroll all the way down.
	smartlist assumes your lines all have the same height.
 * @example
    * <div class="scrollable" smartlist="list | filter:searchvalues" sl-lineheight="21" ng-model="displaylist">
    *  <div ng-repeat="item in displaylist">{{item}}</div>
    * </div>
 * Warning:
    * smartlist only updates during scrolling or when the length of the array changes. This is to prevent having to traverse the whole array apun every digest.
    * You can force updates by broadcasting 'updatesmartlist'. (this will be async)
 */

angular
  .module('posApp')
  .directive('smartlist', ($log, $timeout, $rootScope) => ({
    template:
      "<div ng-style='pageheight'><div ng-style='smartscroller' ng-transclude></div></div>",
    transclude: true,
    require: 'ngModel',

    scope: {
      ngModel: '=',
      slLineheight: '=',
      slMargin: '=',
    },

    link: function ($scope, $element, $attrs) {
      let ov;
      let nv;
      let h;
      let lh = 18;
      let margin = 2; //default of 2 because of the forced even
      $scope.pageheight = {};
      $scope.smartscroller = {
        padding: 0,
        margin: 0,
      };
      const applyscroll = () => {
        const relPos = $element.scrollTop() / h;
        $scope.start = parseInt(relPos * nv);
        $scope.end = $scope.start + parseInt($element.height() / lh) + 1; //+1because top one can be half visible.
        $scope.start -= margin;
        if ($scope.start % 2 > 0) {
          $scope.start--; //without forces even numbers, odd/even line colouring will jump and hurt your eyes during scrolling.
        }
        if ($scope.start < 0) {
          $scope.start = 0;
        }
        $scope.end += margin;
        if ($scope.end > nv) {
          $scope.end = nv;
        }
        $scope.smartscroller['padding-top'] = $scope.start * lh;
        if (angular.isArray($scope.la)) {
          $scope.ngModel = $scope.la.slice($scope.start, $scope.end);
        } else {
          $log.error(
            '[smartlist] smartlist attribute must be of type Array!',
            $scope.la,
          );
        }
      };
      $scope.$watch(() => {
        if ($scope.scrolling) {
          // This fires on scroll due to a model change but it's a waste of time so we bail out quickly
          $scope.scrolling--;
          return;
        }
        //only checking the length should keep things quick, but may not statisfy all needs?
        $scope.la = $scope.$parent.$eval($attrs.smartlist);
        if ($scope.la) {
          nv = $scope.la.length;
          if (ov != nv) {
            if ($scope.slLineheight) {
              lh = $scope.slLineheight;
            }
            h = nv * lh;
            if (h < $element.height()) {
              h = $element.height();
            }
            $scope.pageheight.height = h;
            if ($scope.slMargin) {
              margin = parseInt($scope.slMargin);
            }
            $element.scrollTop(0);
            ov = nv;
            $timeout(applyscroll);
          }
        } else {
          //no array present!
          nv = null;
          $scope.pageheight = {};
          $scope.smartscroller = {
            padding: 0,
            margin: 0,
          };
        }
      });
      $element.bind('scroll', () => {
        $scope.scrolling = 2;
        $timeout(applyscroll);
      });
      $rootScope.$on('updatesmartlist', () => {
        $timeout(applyscroll);
      });
      $rootScope.$on('updatesmartlistheight', () => {
        $scope.la = $scope.$parent.$eval($attrs.smartlist);
        if ($scope.la) {
          if ($scope.slLineheight) {
            lh = $scope.slLineheight;
          }
          h = $scope.la.length * lh;
          if (h < $element.height()) {
            h = $element.height();
          }
          $scope.pageheight.height = h;
          if ($scope.slMargin) {
            margin = parseInt($scope.slMargin);
          }
          $element.scrollTop(0);
          $timeout(applyscroll);
        } else {
          $log.log(
            "Smartlist hasn't encountered a list yet! Broadcasting isn't going to help here.",
          );
        }
      });
    },
  }));
